import React, { useContext } from 'react'
import { styled } from 'linaria/react'
import { SiteContext } from '../../Global/SiteContext'
import UseFormatProductPage from '../../Core/Hooks/UseFormatProductPage'
import { useIntl } from '@jetshop/intl'
import ChannelContext from '@jetshop/core/components/ChannelContext/ChannelContext'
import ListSelect from '../../Core/ListSelect'
import { ReactComponent as PrebookIcon } from '../../../svg/Prebook.svg'
import { ReactComponent as OutOfStockIcon } from '../../../svg/OutOfStock.svg'
import { ReactComponent as InStockIcon } from '../../../svg/InStock.svg'
import { sortStringArray } from '../../Core/Util/Helpers'

const VariantListContainer = styled.div``

const transformPrices = variant => {
   variant.currentPrice = variant.price.incVat
   variant.oldPrice = variant.previousPrice.incVat
   variant.exVatCurrentPrice = variant.price.exVat
   variant.exVatoldPrice = variant.previousPrice.exVat
   return variant
}

const VariantList = ({ productData, selectedVariant, options }) => {
   const { setActiveVariant } = useContext(SiteContext)
   const { selectedChannel } = useContext(ChannelContext)
   const selectedValue = selectedVariant?.values[0]
   const t = useIntl()

   const sortedOptions = sortStringArray(options)

   const listOptions = sortedOptions?.map(optionValue => {
      const variant = productData?.variants?.find(
         v => v?.values[0] === optionValue
      )
      const stockId = variant?.stockStatus?.stockStatusId
      return {
         value: optionValue,
         stockId: stockId,
         indicatorElement: (
            <>
               {stockId == 1 ? (
                  <InStockIcon></InStockIcon>
               ) : stockId == 14 ? (
                  <PrebookIcon></PrebookIcon>
               ) : (
                  <OutOfStockIcon></OutOfStockIcon>
               )}
            </>
         ),
      }
   })

   const noSelectionHeaderEl = (
      <span style={{ alignSelf: 'base-line' }}>
         {t('Select variant')}
         <span style={{ color: 'grey', fontSize: '12px', paddingRight: '8px' }}>
            {' '}
            {t('No variant selected')}
         </span>
      </span>
   )

   const onChange = async selectedValue => {
      if (selectedValue === null || selectedValue === undefined) {
         return
      }
      const url = new URL(window.location.href)
      url.searchParams.set('att', btoa(selectedValue))
      window.history.replaceState({}, '', url.toString())
      const newVariant = productData?.variants?.find(
         v => v?.values[0] == selectedValue
      )
      setActiveVariant(transformPrices(newVariant))
   }

   return (
      <VariantListContainer className="mt-16">
         <ListSelect
            value={selectedValue}
            productData={productData}
            options={listOptions}
            noSelectionHeaderEl={noSelectionHeaderEl}
            onChange={onChange}
         ></ListSelect>
      </VariantListContainer>
   )
}

export default VariantList
